export const CHANGE_MODAL_STATE = 'CHANGE_MODAL_STATE';

interface ChangeModalState {
  type: typeof CHANGE_MODAL_STATE;
  isOpen: boolean;
}

export type ModalState = {
  isOpen: boolean;
};

export type ModalActionTypes = ChangeModalState;